// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/clearances-instructions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/clearances-instructions/clearances-instructions.js';

mount([g0]);
